var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 58 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5 1.5H55.8649C55.6918 2.01464 55.5022 2.60404 55.3124 3.24109C54.6806 5.36217 54 8.16242 54 10.5C54 12.7165 54.6114 15.3437 55.2092 17.4075C55.8753 19.707 55.8137 22.1955 55.0828 24.5084C54.5577 26.1701 54.0464 28.1936 54.0005 29.9611C53.9413 32.2402 54.6358 34.9433 55.282 36.9656C55.4597 37.5217 55.6382 38.0397 55.8042 38.5H5C3.067 38.5 1.5 36.933 1.5 35V5C1.5 3.067 3.067 1.5 5 1.5Z",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "3"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M9 1V17", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M34 1V17", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M29 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M39 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M49 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M44 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M24 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M19 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M14 1V10", stroke: "currentColor", "stroke-width": "3" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M35.9019 28H34.2422V23.4561L34.2583 22.7095L34.2852 21.8931C34.0094 22.1688 33.8179 22.3496 33.7104 22.4355L32.8081 23.1606L32.0078 22.1616L34.5376 20.1475H35.9019V28Z",
          fill: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.2446 24.0737C12.2446 25.4451 12.019 26.4603 11.5679 27.1191C11.1203 27.778 10.4292 28.1074 9.49463 28.1074C8.5887 28.1074 7.90479 27.7673 7.44287 27.0869C6.98454 26.4066 6.75537 25.4022 6.75537 24.0737C6.75537 22.688 6.97917 21.6675 7.42676 21.0122C7.87435 20.3534 8.56364 20.0239 9.49463 20.0239C10.4006 20.0239 11.0845 20.3677 11.5464 21.0552C12.0119 21.7427 12.2446 22.7489 12.2446 24.0737ZM8.4043 24.0737C8.4043 25.0369 8.48665 25.728 8.65137 26.147C8.81966 26.5623 9.10075 26.77 9.49463 26.77C9.88135 26.77 10.1606 26.5588 10.3325 26.1362C10.5044 25.7137 10.5903 25.0262 10.5903 24.0737C10.5903 23.1105 10.5026 22.4194 10.3271 22.0005C10.1553 21.578 9.87777 21.3667 9.49463 21.3667C9.10433 21.3667 8.82503 21.578 8.65674 22.0005C8.48844 22.4194 8.4043 23.1105 8.4043 24.0737Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }